module.exports = "../media/1f6619b0d084f7adff6be82a71a73b1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/guardian.png
// module id = 517
// module chunks = 0